import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetGuestRidesQueryVariables = Types.Exact<{
  where: Types.Guestrides_Bool_Exp;
  order_by?: Types.InputMaybe<Array<Types.Guestrides_Order_By> | Types.Guestrides_Order_By>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetGuestRidesQuery = { __typename?: 'query_root', guestrides: Array<{ __typename?: 'guestrides', id: number, status: string, guest_name: string, guest_phone: string, pickup_address?: string | null, pickup_lat: number, pickup_lng: number, dropoff_address?: string | null, dropoff_lat: number, dropoff_lng: number, provider?: string | null, notes?: string | null, config: object, customer_id: number, created_at: string, created_by?: string | null, updated_at: string, updated_by?: string | null, approval_user_id?: number | null, approval_requested_at?: string | null, approval_notified_at?: string | null, approval_decision?: string | null, approval_decided_at?: string | null, approval_decision_reason?: string | null, approver?: { __typename?: 'users', id: number, display_name: string } | null, ridehails: Array<{ __typename?: 'ridehails', id: number, status?: string | null, provider?: string | null, driver_name?: string | null, driver_phone?: string | null, driver_photo_url?: string | null, pickup_address?: string | null, dropoff_address?: string | null, pickup_at?: string | null, dropoff_at?: string | null, estimated_price?: number | null, actual_price?: number | null, created_at: string, updated_at: string, external_id?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_color?: string | null, vehicle_year?: number | null, vehicle_license_plate?: string | null, vehicle_photo_url?: string | null, quality_rejection_reason?: string | null, tracking_link?: string | null }> }>, guestrides_aggregate: { __typename?: 'guestrides_aggregate', aggregate?: { __typename?: 'guestrides_aggregate_fields', count: number } | null } };


export const GetGuestRidesDocument = gql`
    query GetGuestRides($where: guestrides_bool_exp!, $order_by: [guestrides_order_by!], $limit: Int, $offset: Int) {
  guestrides(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
    id
    status
    guest_name
    guest_phone
    pickup_address
    pickup_lat
    pickup_lng
    dropoff_address
    dropoff_lat
    dropoff_lng
    provider
    notes
    config
    customer_id
    created_at
    created_by
    updated_at
    updated_by
    approval_user_id
    approval_requested_at
    approval_notified_at
    approval_decision
    approval_decided_at
    approval_decision_reason
    approver {
      id
      display_name
    }
    ridehails(order_by: {created_at: desc}, limit: 1) {
      id
      status
      provider
      driver_name
      driver_phone
      driver_photo_url
      pickup_address
      dropoff_address
      pickup_at
      dropoff_at
      estimated_price
      actual_price
      created_at
      updated_at
      external_id
      vehicle_make
      vehicle_model
      vehicle_color
      vehicle_year
      vehicle_license_plate
      vehicle_photo_url
      quality_rejection_reason
      tracking_link
    }
  }
  guestrides_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetGuestRidesQuery__
 *
 * To run a query within a React component, call `useGetGuestRidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestRidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestRidesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetGuestRidesQuery(baseOptions: Apollo.QueryHookOptions<GetGuestRidesQuery, GetGuestRidesQueryVariables> & ({ variables: GetGuestRidesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuestRidesQuery, GetGuestRidesQueryVariables>(GetGuestRidesDocument, options);
      }
export function useGetGuestRidesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuestRidesQuery, GetGuestRidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuestRidesQuery, GetGuestRidesQueryVariables>(GetGuestRidesDocument, options);
        }
// @ts-ignore
export function useGetGuestRidesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGuestRidesQuery, GetGuestRidesQueryVariables>): Apollo.UseSuspenseQueryResult<GetGuestRidesQuery, GetGuestRidesQueryVariables>;
export function useGetGuestRidesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuestRidesQuery, GetGuestRidesQueryVariables>): Apollo.UseSuspenseQueryResult<GetGuestRidesQuery | undefined, GetGuestRidesQueryVariables>;
export function useGetGuestRidesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuestRidesQuery, GetGuestRidesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGuestRidesQuery, GetGuestRidesQueryVariables>(GetGuestRidesDocument, options);
        }
export type GetGuestRidesQueryHookResult = ReturnType<typeof useGetGuestRidesQuery>;
export type GetGuestRidesLazyQueryHookResult = ReturnType<typeof useGetGuestRidesLazyQuery>;
export type GetGuestRidesSuspenseQueryHookResult = ReturnType<typeof useGetGuestRidesSuspenseQuery>;
export type GetGuestRidesQueryResult = Apollo.QueryResult<GetGuestRidesQuery, GetGuestRidesQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (guestrides, guestrides_aggregate): returns the full response object.
 * @source {@link src/features/guestRides/queries/getGuestRides.query.gql}
 */
export async function getGuestRides(
  variables: GetGuestRidesQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetGuestRidesQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetGuestRidesQuery>(
    GetGuestRidesDocument,
    variables,
    requestOptions
  )
}